<template>
  <div class="article_manage">
    <div v-show="!this.show">
      <div class="library_top" v-show="this.switch_classify">
        <div class="top_flex">
          <el-button :class="{green: type.class_id === ''}" @click="getAllArticle">全部</el-button>
          <el-button :key="index" :class="{green: type.class_id === value.class_id}" v-for="(value, index) in this.type.type_list" @click="set_class_id(value.class_id)">{{value.name}}</el-button>
        </div>
        <el-button class="add_category" @click="switch_btn">+</el-button>
      </div>


      <div class="data" v-show="this.switch_classify">
        <div class="data_top">
          <div class="left">
            <el-button @click="add_article">新增文章</el-button>
          </div>
          <div class="right">
            <el-select v-model="article.release_state" class="input_w174">
              <el-option label='已发布' :value=1></el-option>
              <el-option label='未发布' :value=0></el-option>
            </el-select>
            <el-select v-model="article.admin_id" class="input_w174">
              <el-option
                  v-for="item in account.list"
                  :key="item.admin_id"
                  :label="item.name"
                  :value="item.admin_id">
              </el-option>
            </el-select>
            <el-input v-model="article.title" placeholder="文章标题" class="input_w174"></el-input>
            <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                class="input_w240"
                clearable
                value-format="timestamp"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
            </el-date-picker>

            <el-button @click="search">搜索</el-button>
          </div>
        </div>
        <el-table
            id="table"
            :data="article.list"
            :header-cell-style="{background:'rgb(249,249,249)'}"
            ref="multipleTable"
            :row-style="{height: '40px'}"
            style="width: 99%;margin: 0 auto">
          <el-table-column
              align="left"
              prop="title"
              label="文章标题">
          </el-table-column>
          <el-table-column
              prop="class_name"
              width="100"
              label="类别">
            <template v-slot="scope">
              <span v-if="scope.row.class_name === null">未分类</span>
              <span v-else>{{scope.row.class_name}}</span>
            </template>>
          </el-table-column>
          <el-table-column
              prop="create_time"
              align="center"
              width="200"
              label="创建时间">
          </el-table-column>
          <el-table-column
              prop="release_state"
              align="center"
              width="100"
              label="发布状态">
            <template v-slot="scope">
              <span v-if="scope.row.release_state === 1">已发布</span>
              <span v-if="scope.row.release_state === 0">未发布</span>
            </template>>
          </el-table-column>
          <el-table-column
              prop="share_state"
              align="center"
              width="100"
              label="分享人数">
            <template v-slot="scope">
              <span v-if="scope.row.share_state === 1">已分享</span>
              <span v-if="scope.row.share_state === 0">未分享</span>
            </template>>
          </el-table-column>
          <el-table-column
              prop="share_state"
              align="center"
              width="100"
              label="分享次数">
            <template v-slot="scope">
              <span v-if="scope.row.share_state === 1">已分享</span>
              <span v-if="scope.row.share_state === 0">未分享</span>
            </template>>
          </el-table-column>
          <el-table-column
              prop="share_state"
              align="center"
              width="100"
              label="获客数量">
            <template v-slot="scope">
              <span v-if="scope.row.share_state === 1">已分享</span>
              <span v-if="scope.row.share_state === 0">未分享</span>
            </template>>
          </el-table-column>
          <el-table-column
              label="操作"
              width="100">
            <template v-slot="scope">
              <span class="tab_btn" @click="edit_article(scope.row)">编辑</span>
              <span v-show="scope.row.release_state === 0" class="tab_btn" style="color: rgba(249, 104, 104, 1);" @click="release(scope.row)">上线</span>
              <span v-show="scope.row.release_state === 1" class="tab_btn" style="color: rgba(249, 104, 104, 1);" @click="release(scope.row)">下线</span>

            </template>
          </el-table-column>
        </el-table>
        <div class="btn_right">
          <div style="float: right">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="article.pagesize"
                :pager-count='5'
                @size-change="artivle_modify_page"
                @current-change="artivle_switch_page"
                :total="article.article_num">
            </el-pagination>
          </div>

        </div>
      </div>
      <div class="add_category_div" v-show="!this.switch_classify">
        <div class="data_top">
          <div class="left">
            <el-button @click="new_category_open">新增分类</el-button>
          </div>
        </div>
        <el-table
            id="table1"
            :data="type.type_list"
            :header-cell-style="{background:'rgb(249,249,249)'}"
            ref="multipleTable"
            :row-style="{height: '40px'}"
            style="width: 99%;margin: 0 auto">
          <el-table-column
              align="left"
              prop="name"
              label="分类">
          </el-table-column>
          <el-table-column
              prop="is_show"
              width="100"
              align="center"
              label="前台显示">
            <template v-slot="scope">
              <span v-if="scope.row.is_show === 1">显示</span>
              <span v-if="scope.row.is_show === 0">隐藏</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="move"
              align="center"
              width="200"
              label="排序">
          </el-table-column>
          <el-table-column
              label="操作"
              width="100">
            <template v-slot="scope">
              <span class="tab_btn" @click="edit_category_open(scope.row.class_id, scope.row.name, scope.row.is_show)">编辑</span>
              <span class="tab_btn" @click="del_article_public_class(scope.row.class_id)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="btn_right">
          <div style="float: right">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="type.pagesize"
                :pager-count='5'
                @size-change="type_modify_page"
                @current-change="type_switch_page"
                :total="type.type_num">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>


    <Dialog :show.sync="new_category_show" :name_width="new_category" class="dialog">
      <span slot="body">

        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="分类名称">
            <el-input v-model="form.name" class="input_w340"></el-input>
          </el-form-item>
          <el-form-item label="前台显示">
            <el-select v-model="form.is_show" class="input_w340">
              <el-option label='显示' value="1"></el-option>
              <el-option label='隐藏' value="0"></el-option>
            </el-select>
            <p class="tips">隐藏后小程序不显示</p>
          </el-form-item>

        </el-form>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="new_category_save">保 存</el-button>
        <el-button @click="new_category_close">取 消</el-button>
      </div>
    </Dialog>

    <Dialog :show.sync="edit_category_show" :name_width="edit_category" class="dialog">
      <span slot="body">

        <el-form ref="form" :model="this_type_form" label-width="80px">
          <el-form-item label="分类名称">
            <el-input v-model="this_type_form.name" class="input_w340"></el-input>
          </el-form-item>
          <el-form-item label="前台显示">
            <el-select v-model="this_type_form.is_show" class="input_w340">
              <el-option label='显示' value="1"></el-option>
              <el-option label='隐藏' value="0"></el-option>
            </el-select>
            <p class="tips">隐藏后小程序不显示</p>
          </el-form-item>

        </el-form>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="edit_category_save">保 存</el-button>
        <el-button @click="edit_category_close">取 消</el-button>
      </div>
    </Dialog>

    <div v-show="show">
      <div class="create_top" v-if="create_or_edit">
        <span class="create_title">创建文章</span>
        <el-button class="right create_save" @click="save_create_article">保存 创建文章</el-button>
      </div>
      <div class="create_top" v-if="!create_or_edit">
        <span class="create_title">编辑文章</span>
        <el-button class="right create_save" @click="save_edit_article">保存 编辑文章</el-button>
      </div>
      <div class="create_content">
        <div class="content_left">
          <div class="top_title">
            <p class="nowTime">
              4.00PM
              <svg t="1616745970426" class="icon batteryIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2992" width="16" height="16"><path d="M984.2 434.8c-5-2.9-8.2-8.2-8.2-13.9v-99.3c0-53.6-43.9-97.5-97.5-97.5h-781C43.9 224 0 267.9 0 321.5v380.9C0 756.1 43.9 800 97.5 800h780.9c53.6 0 97.5-43.9 97.5-97.5v-99.3c0-5.8 3.2-11 8.2-13.9 23.8-13.9 39.8-39.7 39.8-69.2v-16c0.1-29.6-15.9-55.5-39.7-69.3zM912 702.5c0 12-6.2 19.9-9.9 23.6-3.7 3.7-11.7 9.9-23.6 9.9h-781c-11.9 0-19.9-6.2-23.6-9.9-3.7-3.7-9.9-11.7-9.9-23.6v-381c0-11.9 6.2-19.9 9.9-23.6 3.7-3.7 11.7-9.9 23.6-9.9h780.9c11.9 0 19.9 6.2 23.6 9.9 3.7 3.7 9.9 11.7 9.9 23.6v381z" p-id="2993" fill="#ffffff"></path><path d="M736 344v336c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V344c0-8.8 7.2-16 16-16h608c8.8 0 16 7.2 16 16z" p-id="2994" fill="#ffffff"></path></svg>
              <svg t="1616745697931" class="icon wifiIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2078" width="16" height="16"><path d="M512 256c150.912 0 291.712 57.728 396.501333 162.517333l60.330667-60.330666C847.957333 237.269333 685.696 170.666667 512 170.666667c-173.696 0.042667-335.957333 66.602667-456.832 187.52l60.330667 60.330666C220.288 313.728 361.088 256 512 256z m241.962667 354.432c-131.157333-131.157333-352.768-131.157333-483.925334 0l60.330667 60.330667c98.432-98.432 264.832-98.432 363.264 0l60.330667-60.330667z" fill="#ffffff" p-id="2079"></path><path d="M871.978667 481.834667c-195.072-195.157333-524.842667-195.157333-719.914667 0l60.330667 60.330666c162.432-162.432 436.821333-162.432 599.253333 0l60.330667-60.330666z" fill="#ffffff" p-id="2080"></path><path d="M512 768m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" fill="#ffffff" p-id="2081"></path></svg>
            </p>
            <p class="cardTitle">{{article_info.title}}</p>
          </div>
          <div class="phoneContent">
            <div>
              <div class="articleHead">
                <h1>{{article_info.title}}</h1>
                <div class="artiInfo">
                  <span>2021-3-26 15:55:52</span>
                </div>
                <div class="articleBody" v-html="article_info.content">
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="content_right">
          <el-form ref="article" :model="article_info">
            <el-form-item label="文章标题">
              <el-input v-model="article_info.title" placeholder="请输入内容" class="mt10"></el-input>
            </el-form-item>
            <el-form-item label="前台展示">
              <el-select v-model="article_info.release_state" class="input_w340">
                <el-option label='已发布' :value=1></el-option>
                <el-option label='未发布' :value=0></el-option>
              </el-select>
              <span class="tips1">文章是否在小程序文章内显示</span>
            </el-form-item>
            <el-form-item label="">
              <div class="wang_editor">
              </div>
            </el-form-item>
            <el-form-item label="" v-show="!this.more_show">
              <div style="width: 130px;margin: 0 auto">
                <span class="font_color">
                  <svg t="1616552786381" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5521" width="16" height="16"><path d="M959.429379 343.214852 890.590548 274.378068 511.268336 653.699256 131.944078 274.378068 63.105247 343.214852 501.1857 781.294282 521.348925 781.294282Z" p-id="5522" fill="rgb(39,165,56)"></path></svg>
                </span>
                <span class="font_color" style="margin-left: 10px" @click="more_open">更多文章设置</span>
              </div>
            </el-form-item>
            <el-form-item label="" v-show="this.more_show">
              <label slot="label">封面和摘要<span class="tips1">（请上传jpg、png格式的图片，不超过1M，尺寸建议为60*60px）</span></label>
              <div style="display: flex; margin-top: 20px;" :class="{upload: upload_div_show}">
                <el-upload
                    v-if="create_or_edit"
                    ref="uploads"
                    style="display: inline-block"
                    action="upload"
                    accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                    :http-request="add_article_public"
                    list-type="picture-card"
                    :auto-upload="false"
                    :limit="1"
                    :data="article_info"
                    :before-upload="beforeUpload"
                    :on-change="handleChange"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                  <span class="upload_span">上传图片</span>
                </el-upload>
                <el-upload
                    v-if="!create_or_edit"
                    ref="edit_uploads"
                    style="display: inline-block"
                    action="upload"
                    :http-request="edit_article_public"
                    list-type="picture-card"
                    :auto-upload="false"
                    :limit="1"
                    :data="article_info"
                    :file-list="listArr"
                    :before-upload="beforeUpload1"
                    :on-change="handleChange"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                  <span class="upload_span">上传图片</span>
                </el-upload>
                <el-dialog :visible="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="选填，摘要会在文章分享视显示，帮助读者快速了解内容，如不填写则默认为空"
                    v-model="article_info.abstract">
                </el-input>
                <el-input v-model="input1" placeholder="选填，原文链接" class="mt10" style="display: none"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="" v-show="this.more_show">
              <label slot="label">分类<span class="add" @click="new_category_open">新建分类</span></label>
              <el-select @change="getAllClassList" v-model="article_info.class_id" placeholder="请选择" class="mt10" style="width: 100%;">
                <el-option
                    v-for="item in type.type_list"
                    :key="item.class_id"
                    :label="item.name"
                    :value="item.class_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" v-show="this.more_show">
              <div style="width: 130px;margin: 0 auto">
            <span class="font_color">
            <svg t="1616554930997" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7258" width="16" height="16"><path d="M96.196 671.807l415.804-415.632 415.803 415.632-63.616 63.445-352.209-352.017-352.102 352.017z" p-id="7259" fill="rgb(39,165,56)"></path></svg>
          </span>
                <span class="font_color" style="margin-left: 10px" @click="more_close">更多文章设置</span>
              </div>
            </el-form-item>

          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Dialog from "components/content/dialog/Dialog";
import WangEditor from "components/content/wangeditor/WangEditor";


import {delArticle} from 'network/hk_article'
import {get_article_public_class_list, del_article_public_class, edit_article_public_class, add_article_public_class, get_article_public_list, add_article_public, edit_article_public, articleRelease} from 'network/hk_admin_article'
import {getAdminList} from 'network/hk_admin_account'
import E from "wangeditor";


let fd = new FormData()

export default {
  name: "ArticleManage",
  components: {
    Dialog
  },
  data() {
    return {
      type: {
        // 文章类别每页数量
        pagesize: 10,
        page: 1,
        // 类别数量
        type_num: 0,
        // 类别列表
        type_list: [],
        class_id: '',
      },
      article: {
        list: [],
        pagesize: 10,
        page: 1,
        article_num: 0,
        class_id: '',
        title: '',
        search_time: [],
        release_state: 1,
        admin_id: 2
      },
      create_article: {

      },

      account: {
        admin_id: 2,
        list: []
      },
      source: {
        list: [{
          value: '1',
          label: '全部状态'
        },{
          value: '2',
          label: '文章'
        },{
          value: '3',
          label: '名片'
        },{
          value: '4',
          label: '海报'
        },{
          value: '5',
          label: '表单'
        },{
          value: '6',
          label: '视频'
        },],
        value: '全部状态'
      },
      source1: {
        list: [{
          value: '1',
          label: '全部账号'
        },{
          value: '2',
          label: '文章'
        },{
          value: '3',
          label: '名片'
        },{
          value: '4',
          label: '海报'
        },{
          value: '5',
          label: '表单'
        },{
          value: '6',
          label: '视频'
        },],
        value: '全部账号'
      },
      show: false,


      // 类别列表
      type_list: [],
      // 默认类别
      default_type: '',

      // 创建文章表单
      article_info: {
        title: '',
        release_state: 1,
        content: '',
        image: '',
        abstract: '',
        class_id: null
      },
      listArr: [
        {
          name: '',
          url: ''
        },
      ],

      upload_div_show: false,


      input1: '',

      phoneEditor: '',
      name: '',

      more_show: false,



      textarea: '',
      dialogImageUrl: '',
      dialogVisible: false,
      // 新建分类
      new_category: {
        name: '新建分类',
        width: '500px'
      },
      new_category_show: false,
      // 编辑分类
      edit_category: {
        name: '编辑分类',
        width: '500px'
      },
      edit_category_show: false,
      edit_article_show: false,


      select_members_show: false,
      switch_classify: true,
      input: '',
      value1: '',
      value: '',
      value2: '',
      form: {
        name: '',
        is_show: '1'
      },
      this_type_form: {
        class_id: null,
        name: '',
        is_show: '1'
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [date, new Date()]);
          }
        },{
          text: '本周',
          onClick(picker) {
            var nowTemp = new Date();//当前时间
            var oneDayLong = 24*60*60*1000 ;//一天的毫秒数
            var c_time = nowTemp.getTime() ;//当前时间的毫秒时间
            var c_day = nowTemp.getDay()||7;//当前时间的星期几
            var m_time = c_time - (c_day-1)*oneDayLong;//当前周一的毫秒时间
            var monday = new Date(m_time);//设置周一时间对象
            var m_year = monday.getFullYear();
            var m_month = monday.getMonth()+1;
            var m_date = monday.getDate();
            var start =  m_year+'-'+m_month+'-'+m_date//周一的年月日
            const end = new Date();
            // const start = new Date(new Date().getMonth(), 0);
            picker.$emit('pick', [start, end]);
          }
        },{
          text: '本月',
          onClick(picker) {
            var date = new Date(), y = date.getFullYear(), m = date.getMonth();
            var firstDay = new Date(y, m, 1);
            const end = new Date();
            const start = new Date(new Date().getMonth(), 0);
            picker.$emit('pick', [firstDay, end]);
          }
        },{
          text: '本年',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        },{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  created() {
    this.getAllClassList()
    this.getAllArticleList(this.article.pagesize, this.article.page)
    this.getAdminList()
  },
  computed: {
    create_or_edit() {
      var length = Object.keys(this.article_info).length
      if (length === 6) {
        return true
      }
    },


  },
  watch: {
    article_info: {
      handler() {
        if (this.article_info.image !== '') {
          this.listArr[0].url = this.article_info.image
          this.upload_div_show = true
        }
      }
    }
  },

  methods: {
    // 获取用户列表
    getAdminList() {
      getAdminList().then(res => {
        if (res.code === 10000) {
          this.account.list = res.result
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    getAllArticle() {
      this.type.class_id = ''
      this.article.class_id = ''
      this.getAllArticleList(this.article.pagesize, this.article.page)
    },

    add_article() {
      this.show = true
    },
    // 保存 创建文章
    save_create_article() {
      this.$refs.uploads.submit();
      this.show = false
    },
    save_edit_article() {
      fd.append('article_id', this.article_info.article_id)
      fd.append('title', this.article_info.title)
      fd.append('content', this.article_info.content)
      fd.append('release_state', this.article_info.release_state)
      fd.append('abstract', this.article_info.abstract)
      fd.append('class_id', this.article_info.class_id)


      this.edit_article_public(fd)
      this.$refs.edit_uploads.submit()

      this.show = false
    },
    more_open() {
      this.more_show = true
    },
    more_close() {
      this.more_show = false
    },
    handleRemove(file, fileList) {
      this.upload_div_show = false
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange (file) {
      this.article_info.image = file
      this.upload_div_show = true
    },
    beforeUpload (file) {
      let fd = new FormData()
      fd.append('title', this.article_info.title)
      fd.append('content', this.article_info.content)
      fd.append('release_state', this.article_info.release_state)
      fd.append('abstract', this.article_info.abstract)
      fd.append('class_id', this.article_info.class_id)
      fd.append('image', file)
      add_article_public(fd).then(res => {

      })
      return true
    },
    beforeUpload1 (file) {

      fd.append('image', file)
    },



    getTableLength() {
      return this.type.type_list.length
    },

    switch_btn() {
      this.get_article_public_class_list(this.type.pagesize, this.type.page)
      this.switch_classify = false
    },
    edit_article(article) {
      // this.$emit('update:show', true)
      this.show = true
      this.article_info = article
      this.phoneEditor.txt.html(article.content)
    },

    // 新建分类
    new_category_open() {
      this.new_category_show = true;
    },
    new_category_close() {
      this.new_category_show = false;
    },
    new_category_save() {
      this.add_article_public_class(this.form.name, this.form.is_show)
      this.get_article_public_class_list(this.type.pagesize, this.type.page)
      this.form.name = ''
      this.new_category_show = false;
    },
    // 编辑分类
    edit_category_open(class_id, name, is_show) {
      this.this_type_form.class_id = class_id
      this.this_type_form.name = name
      this.this_type_form.is_show = is_show.toString()
      this.edit_category_show = true;
    },
    edit_category_close() {
      this.edit_category_show = false;
    },
    edit_category_save() {
      this.edit_article_public_class(this.this_type_form.class_id, this.this_type_form.name, this.this_type_form.is_show)
      this.get_article_public_class_list(this.type.pagesize, this.type.page)
      this.edit_category_show = false;
    },

    click() {
      this.$emit('update:show', true)
    },
    search() {
      this.article.search_time = []

      this.article.search_time.push(this.value1[0]/1000)
      this.article.search_time.push(this.value1[1]/1000)

      this.article.search_time = JSON.stringify(this.article.search_time)

      if( this.article.search_time=='[null,null]'){
        this.article.search_time=[]
      }

      this.get_article_public_list(this.article.pagesize, this.article.page, this.article.title, this.article.class_id, this.article.admin_id, this.article.search_time, this.article.release_state)
    },
    // 创建文章
    add_article_public(data) {
      add_article_public(data).then(res => {
        if (res.code === 10000) {
          this.getAllArticle()
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },


    // 切换类别
    set_class_id(class_id) {
      this.type.class_id = class_id
      this.article.class_id = class_id
      this.get_article_public_list(this.article.pagesize, this.article.page, this.article.title, this.article.class_id,  this.article.search_time)
    },
    // 获取文章列表
    get_article_public_list(pagesize, page, title, class_id, admin_id, search_time, release_state) {
      get_article_public_list(pagesize, page, title, class_id, admin_id, search_time, release_state).then(res => {
        if (res.code === 10000) {
          this.article.list = res.result.article.data
          this.article.article_num = res.result.article.total
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    getAllArticleList(pagesize, page) {
      get_article_public_list(pagesize, page).then(res => {
        if (res.code === 10000) {
          this.article.list = res.result.article.data
          this.article.article_num = res.result.article.total
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 获取文章类别列表
    get_article_public_class_list(pagesize, page) {
      get_article_public_class_list(pagesize, page).then(res => {
        if (res.code === 10000) {
          this.type.type_list = res.result.data
          this.type.type_num = res.result.total
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 获取全部类别列表
    getAllClassList() {
      get_article_public_class_list().then(res => {
        if (res.code === 10000) {
          this.type.type_list = res.result
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 类别列表 每页几条数据
    type_modify_page(val) {
      this.type.pagesize = val
      this.get_article_public_class_list(this.type.pagesize, this.type.page)
    },
    // 类别列表 切换页码
    type_switch_page(val) {
      this.type.page = val
      this.get_article_public_class_list(this.type.pagesize, this.type.page)
    },

    // 类别列表 每页几条数据
    artivle_modify_page(val) {
      this.article.pagesize = val
      this.get_article_public_list(this.article.pagesize, this.article.page, this.article.class_id, this.article.title, this.article.search_time)
    },
    // 类别列表 切换页码
    artivle_switch_page(val) {
      this.article.page = val
      this.getAllArticleList(this.article.pagesize, this.article.page)
    },
    // 修改文章类别
    edit_article_public_class(class_id, name, is_show) {
      edit_article_public_class(class_id, name, is_show).then(res => {
        if (res.code === 10000) {
          this.$message('修改成功');
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 删除文章类别
    del_article_public_class(class_id) {
      del_article_public_class(class_id).then(res => {
        if (res.code === 10000) {
          this.$message('删除成功');
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
      this.get_article_public_class_list(this.type.pagesize, this.type.page)
    },
    // 添加文章类别
    add_article_public_class(name, is_show) {
      add_article_public_class(name, is_show).then(res => {
        if (res.code === 10000) {
          this.$message('添加成功');
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },

    // 删除文章
    delArticle(article_id) {
      delArticle(article_id).then(res => {
        if (res.code === 10000) {
          this.$message('删除成功');
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },

    // 修改文章
    edit_article_public(data) {
      edit_article_public(data).then(res => {
        if (res.code === 10000) {
          this.$message('修改成功');
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },
    // 发布状态
    articleRelease(article_id, release_state) {
      articleRelease(article_id, release_state).then(res => {
        if (res.code === 10000) {
          this.getAllArticleList(this.article.pagesize, this.article.page)
        } else if (res.code === 10001 && res.message === '请重新登录') {
          this.clearToken()
        }
      })
    },


    release(article) {
      let release_state = null
      if (article.release_state === 1) {
        release_state = 0
      } else {
        release_state = 1
      }
      this.articleRelease(article.article_id, release_state)
    }
  },
  mounted() {
    // wangeditor
    this.phoneEditor = new E('.wang_editor')
    // this.phoneEditor.config.zIndex = 0

    this.phoneEditor.config.onchange = (html) => {
      this.article_info.content = html
    }

    this.phoneEditor.create()
    // 富文本内容
    this.phoneEditor.txt.html()

  },
}
</script>

<style scoped>
.article_manage {
  position: absolute;
  /*width: 88%;*/
  min-width: 958px;
  padding: 0;
  padding-bottom: 10px;
  margin-top: 60px;
  padding-right: 10px;
  right: 0;
  left: 160px;
  height: auto;
  overflow: hidden;
}

.library_top {
  width: 100%;
  background-color: #FFFFFF;
  padding-bottom: 10px;
}


.top_flex {
  width: 90%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: center;
  position: relative;
}
/deep/ .top_flex .el-button {
  border-radius: 2px;
  height: 32px;
  line-height: 0px;
  padding: 10px 15px;
  background: rgb(242,242,242);
  border: none;
  color: rgba(56, 56, 56, 1);
  margin: 10px 10px 0px 10px;
}
.add_category {
  position: absolute;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  line-height: 0px;
  padding: 0;
  background: rgb(242,242,242);
  border: none;
  color: rgba(56, 56, 56, 1);
  right: 30px;
  top: 10px;
}
.green {
  background: rgb(200,232,205)!important;
  color: rgb(39,165,56)!important;
}
.data {
  background: #fff;
  margin-top: 15px;
}
.add_category_div {
  height: auto;
  background: #fff;
  margin-top: 15px;
}
.data_top {
  width: 100%;
  height: 55px;
}
.left {
  float: left;
  margin-top: 10px;
  margin-left: 10px;
}
.right {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}
.btn_right {
  height: 50px;
  margin-top: 15px;
  margin-right: 10px;
}
.input_w174 {
  width: 174px;
  margin-right: 5px;
}
.input_w240 {
  width: 240px;
  margin-right: 5px;
}
.right>.el-button {
  width: 50px;
  height: 32px;
  padding: 0;
  background: rgb(39,165,56);
  color: #fff;
  border: none;
}
.right>.el-button:hover {
  background: rgb(24,134,39);
}

.left>.el-button {
  width: 80px;
  height: 32px;
  padding: 0;
  background: rgb(39,165,56);
  color: #fff;
  border: none;
}
.left>.el-button:hover {
  background: rgb(24,134,39);
}
.export {
  background: rgb(38,138,240)!important;
}
/deep/ .el-input__inner:focus {
  border-color: rgb(39,165,56);
}
/deep/ .el-button--primary {
  background-color: rgb(39,165,56);
  border-color: rgb(39,165,56);
}
/deep/ .el-button--primary:hover {
  background-color: rgb(24,134,39);
}



.create_top {
  width: 100%;
  height: 50px;
  background-color: #FFFFFF;
  margin-top: 15px;
}
.create_title {
  font-size: 16px;
  color: rgba(56, 56, 56, 1);
  line-height: 50px;
  margin-left: 15px;
}
.right {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}
.create_save {
  border-radius: 2px;
  width: 120px;
  height: 36px;
  background-color: rgba(39, 165, 56, 1);
  padding: 0;
  color: #FFFFFF;
  margin-top: 7px;
  border: none;
}
.create_save:hover {
  background-color: rgba(24,134,39, 1);
  color: #FFFFFF;
}
.create_content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 15px;
}
.content_left {
  width: 375px;
  min-width: 375px;
  background: #FFFFFF;
  display: inline-block;
  margin: 0;
  height: auto;
  box-shadow: 0 1px 4px rgb(0 0 0 / 4%);
  opacity: 1;
  border-radius: 4px;
}
.top_title {
  width: 100%;
  height: 64px;
  background: rgb(39,165,56);
  color: #fff;
}
.nowTime {
  font-size: 12px;
  padding-left: 22px;
  padding-top: 5px;
  overflow: hidden;
}
.nowTime .icon {
  width: 1em;
  height: 1em;
  vertical-align: -.15em;
  margin-right: 6px;
  fill: currentColor;
  overflow: hidden;
}
.icon.batteryIcon {
  float: right;
  font-size: 16px;
  margin-right: 23px;
}
.icon.wifiIcon {
  float: right;
  font-size: 16px;
  margin-right: 6px;
}
.cardTitle {
  font-size: 16px;
  margin-top: 5px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  padding: 0 8px;
}
.phoneContent {
  overflow-y: auto;
  overflow-x: hidden;
  height: 700px;
  background: #fff;
}
.phoneContent>div {
  min-height: 700px;
  padding: 8px 16px;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.phoneContent>div>div {
  position: relative;
}
.articleHead H1 {
  color: #1f211f;
  padding: 5px 0;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  font-size: 22px;
  margin-bottom: 9px;
}

.articleHead .artiInfo {
  color: rgba(31,33,31,.3);
  font-size: 15px;
  line-height: 20px;
}
.phoneContent .articleBody {
  padding-top: 10px;
  color: #1f211f;
  font-size: 14px;
}

.content_right .font_color {
  cursor: pointer;
  font-size: 14px;
}

/deep/ .create_content .content_right .el-form-item__label{
  float: none;
}
/deep/ .create_content .content_right .el-form-item__content {
  margin-left: 0;
}

.content_right {
  width: 100%;
  height: auto;
  background: #FFFFFF;
  margin-left: 20px;
  padding: 50px;
}
.div_box {
  width: 90%;
  margin: 20px auto;
}
.box_title {
  font-size: 14px;
  color: rgba(56, 56, 56, 1);
}
.content_right .add {
  float: right;
  color: rgb(39,165,56);
  cursor: pointer;
}
.wang_editor {
  position: relative;
  z-index: 0;
}



.mt10 {
  margin-top: 10px;
}
.tips1 {
  font-size: 12px;
  color: rgba(166, 166, 166, 1);
  margin-left: 10px;
}
.font_color {
  color: rgb(39,165,56);
}
/deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: rgb(242,242,242);
  border: none;
  border-radius: 1px;
}
/deep/ .el-input__inner {
  border-radius: 2px;
}

/deep/ .el-upload--picture-card i {
  font-size: 18px;
  position: relative;
  left: 28px;
  top: -9px;
}
.upload_span {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  position: relative;
  top: 9px;
  left: -8px;
}
/deep/ .upload .el-upload--picture-card {
  display: none;
}

.el-textarea {
  width: 80%;
  height: 80px;
  margin-left: 10px;
}
/deep/ .el-textarea__inner {
  height: 100%;
  padding: 0;
  border-radius: 2px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
/deep/ .el-input__inner:focus {
  border: 1px solid rgb(39,165,56);
}
/deep/ .el-textarea__inner:focus {
  border: 1px solid rgb(39,165,56);
}


</style>
  <style>

  .el-date-editor .el-range-separator {
    line-height: 23px;
  }

.el-input__icon {
  line-height: 30px;
}
.el-date-editor .el-range__icon {
  line-height: 25px;
}
.el-date-editor .el-range__close-icon {
  line-height: 25px;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: rgb(39,165,56);
}
.el-select .el-input__inner:focus {
  border-color: rgb(39,165,56);
}
.el-select .el-input__inner:hover {
  border-color: rgb(39,165,56);
}
.el-range-editor.is-active, .el-range-editor.is-active:hover {
  border-color: rgb(39,165,56);
}
.el-table th>.cell {
  color: rgba(56, 56, 56, 1);
}
.el-select-dropdown__item.selected {
  color: rgb(39,165,56);
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgb(39,165,56);
}
.btn-prev {
  width: 64px;
  height: 32px;
}
.btn-next {
  width: 64px;
  height: 32px;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: 1px solid rgb(207,207,207);
}
.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: rgb(39,165,56);
}
</style>